module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/vendor-67c0dc6b55dd3f021b88757185189cb4.png";